'use strict';

var _classCallCheck = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/Users/vedantvyas/chromafan-web/node_modules/@babel/runtime/helpers/inherits");

var globby = require('globby');

var path = require('path');

var protobuf = require('protobufjs');

var COMMON_PROTO_FILES;

var GoogleProtoFilesRoot =
/*#__PURE__*/
function (_protobuf$Root) {
  _inherits(GoogleProtoFilesRoot, _protobuf$Root);

  function GoogleProtoFilesRoot() {
    _classCallCheck(this, GoogleProtoFilesRoot);

    return _possibleConstructorReturn(this, _getPrototypeOf(GoogleProtoFilesRoot).call(this, [].slice.apply(arguments)));
  } // Caches and returns an array of the local common/google core proto files
  // exist on disk.


  _createClass(GoogleProtoFilesRoot, [{
    key: "resolvePath",
    // Causes the loading of an included proto to check if it is a common
    // proto. If it is a common proto, use the google-proto-files proto.
    value: function resolvePath(_, includePath) {
      includePath = path.normalize(includePath); // Fully qualified paths don't need to be resolved.

      if (path.isAbsolute(includePath)) {
        return includePath;
      }

      var fullIncludePath = path.join(__dirname, path.relative(__dirname, includePath));
      var commonProtoFiles = GoogleProtoFilesRoot.getCommonProtoFiles();

      if (commonProtoFiles.indexOf(fullIncludePath) > -1) {
        return fullIncludePath;
      }

      return protobuf.util.path.resolve.apply(null, [].slice.call(arguments));
    }
  }], [{
    key: "getCommonProtoFiles",
    value: function getCommonProtoFiles() {
      var commonProtoDirs = [// This list of directories is defined here:
      // https://github.com/googleapis/googleapis/blob/master/gapic/packaging/common_protos.yaml
      'api', path.join('logging', 'type'), 'longrunning', 'protobuf', // This is an additional path that the common protos depend on.
      'rpc', 'type'];
      var commonProtoGlobPatterns = commonProtoDirs.map(function (dir) {
        return path.join(__dirname, 'google', dir, '**', '*.proto');
      });

      if (!COMMON_PROTO_FILES) {
        COMMON_PROTO_FILES = globby.sync(commonProtoGlobPatterns).map(path.normalize);
      }

      return COMMON_PROTO_FILES;
    }
  }]);

  return GoogleProtoFilesRoot;
}(protobuf.Root);

module.exports.loadSync = function (filename, options) {
  var root = new GoogleProtoFilesRoot();
  return root.loadSync(filename, options);
};

module.exports.load = function (filename, options) {
  var root = new GoogleProtoFilesRoot();
  return root.load(filename, options);
};

module.exports.GoogleProtoFilesRoot = GoogleProtoFilesRoot;